import React, {useState, useEffect, useRef} from "react";
import {useForm, FormProvider, useFormContext, useWatch} from "react-hook-form";
import BasicInfo from "./FormComponents/BasicInfo"; 
import WebsiteGoals from "./FormComponents/WebsiteGoals";
import BrandingAndStylePreferences from "./FormComponents/BrandingAndStylePreferences"
import NotificationBar from "../../components/NotificationBar";
import { CircularProgress } from "@mui/material";
import { LiaCheckCircleSolid } from "react-icons/lia";

function WebsiteBriefForm() {
   const methods = useForm({
        mode: "onChange", // enables real-time validation
    });
    const [submitted, setSubmitted] = useState(false);


    const { handleSubmit, reset, formState: { isSubmitting } } = methods;

    const [openNotificationBar,setOpenNotificationBar] =useState(false)
    const [showError,setShowError] =useState("");
    const [errorMessage,setErrorMessage] =useState(false);
    const [showMessage,setShowMessage] = useState(false)
      const formRef = useRef();
 
    const { watch } = methods;
    const onSubmit = async(data) => {
if (Object.keys(data).length === 0) return;
      try {
          //  console.log(data);
        const response = await fetch(
          "https://brief-form.affan-8e4.workers.dev/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data ),
        }
      );
       
        
        if (!response.ok) {
         setErrorMessage(true)
        const text = await response.text();
        throw new Error(`Server error ${response.status}: ${text.slice(0, 100)}`);
      }

     let result;
      try {
        result = await response.json();
      } catch {
        const text = await response.text();
        throw new Error(`Invalid JSON response: ${text.slice(0, 100)}...`);
      }
      const { success, error } = result || {};
       
      
      if (!success) {
        // setShowError( "Failed to submit data. Please try again.");
        // // reset();
        
        return;  
      } else {
        setShowError("")
        setSubmitted(true )
        // console.log(result)
        setOpenNotificationBar(true)
        reset();
        setTimeout(() => {
          setStep(1)
  setShowMessage(true);
}, 2000);

          
        }
    } catch (err) {
      // console.error("Submission error:", err);
      setShowError("Failed to submit data. Please try again.");
    } 
    };
    

const [isPreviosAnimation, setIsPreviosAnimation] = useState(false);
    const [step, setStep] = useState(1);
 
    const nextStep = () => setStep(step + 1);
 
    const prevStep = () => setStep(step - 1);


    const steps = [
      {component: BasicInfo},
      {component: WebsiteGoals},
      {component: BrandingAndStylePreferences}, 
    ];

    const CurrentStepComponent = steps[step - 1].component;

    const sharedProps = {
        isPreviosAnimation,
        setIsPreviosAnimation, 
    };

   

    return ( 
        <>
        <div className="container">
                  {/* <NotificationBar
                   open={openNotificationBar} setOpen={setOpenNotificationBar}/> */}
                                    
            
        {  
        showMessage ? (  <div className="h-screen flex flex-col justify-center items-center">
               <LiaCheckCircleSolid color="#DF73FF" size='5rem'/>
               <h2 className="text-dark font-bold text-2xl">Thank you! </h2>
               <p className="text-dark">Your application was submitted successfully.</p>

            </div>)  :( 
                <div className=" md:w-10/12 lg:w-9/12  mx-auto   py-40">
              <div className="shadow[20px_20px_20px_20px_#000] p-10 shadow rounded-xl">

                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)}  noValidate
           ref={formRef}
>            


                        <CurrentStepComponent prevStep={prevStep} nextStep={nextStep}  handleSubmit={onSubmit}      isSubmitting={isSubmitting}  submitted={submitted}
 {...sharedProps} errorMessage={errorMessage} />
                    </form>
                </FormProvider>
              </div>
            </div>)
          
            }
              
            </div>

            {/* showError ? (
                        <div className="h-screen flex flex-col justify-center items-center">
      <h2 className="text-red-600 font-bold text-2xl mb-4">Submission Failed!</h2>
      <p className="text-red-600 mb-4 ">Failed to submit the data. Please <span className="underline decoration-red-600 cursor-pointer" onClick={() => {
             setShowError("");
            setStep(1); 
         reset();    
        }}>Try again.</span></p>
      
   </div>
                    ): */}
        </>
    );
}
export default WebsiteBriefForm;
